import React from 'react';

import type { Task } from '../services/taskService';
import { unrepresentedPlanningStages } from '../utils/planningTaskPresentation';

import { TaskStatusSpinner } from './TaskStatusSpinner';

import './PlanningTaskStageStatus.css';

/** Preserve stage-only recovery information without adding duplicate page tasks. */
export const PlanningTaskStageStatus: React.FC<{ tasks: Task[] }> = ({ tasks }) => (
  <>
    {unrepresentedPlanningStages(tasks).map((task) => (
      <div key={task.id} className="planning-stage-status" role={task.status === 'error' ? 'alert' : 'status'}>
        <TaskStatusSpinner status={task.status} />
        <span>Page design: {task.execution_step || task.status.replace(/_/g, ' ')}</span>
      </div>
    ))}
  </>
);
